import React, { useState, useEffect, Fragment } from 'react';
import { Line } from 'react-chartjs-2';
import { CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Chart as ChartJS } from 'chart.js';
import { Box, Typography } from '@mui/material';
import CustomDropDown from '../CustomDropDown/CustomDropDown';
import AxiosInstance from '../../Config/AxiosInstance';
import APILIST from '../../Config/ApiList';
import Skeleton from 'react-loading-skeleton';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const CustomLineChart = (props) => {
    const {isLoading} = props;
    const [isSelectRange, setSelectRange] = useState(2);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                label: 'Interpreters',
                borderColor: '#00AD3C',
                backgroundColor: 'rgba(0, 173, 60, 0.2)',
                fill: true,
            },
            {
                data: [],
                label: 'Users', 
                borderColor: '#FF5733',
                backgroundColor: 'rgba(255, 87, 51, 0.2)',
                fill: true,
            },
        ],
    });
    const isSelectRangeList = [
        { name: 'Weekly', id: 1 },
        { name: 'Monthly', id: 2 },
        { name: 'Yearly', id: 3 },
    ];
    useEffect(() => {
        getDashboardChartData();
    }, [isSelectRange]);
    const getDashboardChartData = async () => {
        try {
            const response = await AxiosInstance.get(APILIST.GET_DASHBOARD_LINE_CHART, {
                params: {
                    type: isSelectRange, 
                },
            });

            if (response && response.data && response.data.r) {
                let labels = [];
                let interpretersData = [];
                let usersData = [];

                if (isSelectRange === 1) {
                    labels = response.data.r.map(item => item.day);
                    interpretersData = response.data.r.map(item => item.interpreters || 0); 
                    usersData = response.data.r.map(item => item.users || 0); 
                } else if (isSelectRange === 2) {
                    labels = response.data.r.map(item => item.month); 
                    interpretersData = response.data.r.map(item => item.interpreters || 0); 
                    usersData = response.data.r.map(item => item.users || 0); 
                } else if (isSelectRange === 3) {
                    labels = response.data.r.map(item => item.year); 
                    interpretersData = response.data.r.map(item => item.interpreters || 0); 
                    usersData = response.data.r.map(item => item.users || 0); 
                }
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            data: interpretersData,
                            label: 'Interpreters', 
                            borderColor: 'rgba(0, 151, 178, 1)',
                            backgroundColor: 'rgba(0, 151, 178, 1)',
                            fill: true,
                        },
                        {
                            data: usersData,
                            label: 'Users', 
                            borderColor: 'rgba(0, 67, 103, 1)',
                            backgroundColor: 'rgba(0, 67, 103, 1)',
                            fill: true,
                        },
                    ],
                });
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
        }
    };

    return (
        <Fragment>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px',
                    marginBottom: '20px',
                }}
            >
                <Typography
                    sx={{
                        color: 'rgba(8, 85, 127, 1)',
                        fontSize: '18px',
                        fontWeight: '600',
                        fontFamily: 'Outfit',
                        textAlign: 'left',
                    }}
                >
                    User Activity
                </Typography>
                <CustomDropDown
                    sx={{ height: '46px' }}
                    placeholder={'Select Filter'}
                    menuList={isSelectRangeList}
                    value={isSelectRange}
                    getLabel={(item) => item?.name}
                    onChange={(e) => setSelectRange(e.target.value)}
                />
            </Box>
            <div style={{ width: '100%', height: '300px', backgroundColor: '#fff' }}>
                {isLoading ? <Skeleton height={300}/> : <Line
                    data={chartData}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                type: 'category',
                                ticks: {
                                    color: '#000',
                                },
                            },
                            y: {
                                type: 'linear',
                                ticks: {
                                    color: '#000',
                                    display: false,  // Hide y-axis labels
                                },
                            },
                        },
                        elements: {
                            line: {
                                tension: 0.4,
                            },
                        },
                        layout: {
                            padding: {
                                left: 10,
                                right: 10,
                                top: 10,
                                bottom: 10,
                            },
                        },
                        plugins: {
                            legend: {
                                display: true,
                                position: 'top', 
                            },
                        },
                    }}
                />}
            </div>
        </Fragment>
    );
};

export default CustomLineChart;
